import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dividerContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
    },
    divider: {
        flexGrow: 1,
    },
    dividerText: {
        margin: theme.spacing(0, 2),
    },
}));

const DividerWithText = ({ text, style }) => {
    const classes = useStyles();

    return (
        <div className={classes.dividerContainer} style={style}>
            <Divider className={classes.divider} />
            <Typography className={classes.dividerText}>{text}</Typography>
            <Divider className={classes.divider} />
        </div>
    );
};

export default DividerWithText;